export default __webpack_public_path__ + "static/media/logo_posivna.4351e186.webp";